<div class="page">
     <div class="content">
        <h1>Error!</h1>
        <p>
            You do not have access to this application, please contact system administrator.
        </p>
    </div>
    <div class="footer">
        <button (click)="logout()">
            <img src="assets/images/change-user.svg" alt="add" class="action-image">
            Switch User
        </button>
        <button (click)="redirectToHomePage()" [class.disabled]="isTokensRefreshing()">
            <img src="assets/images/retry.svg" alt="add"
                class="action-image"
                [class.loading]="isTokensRefreshing()">
            Try Again
        </button>
    </div>
</div>
